module.exports = __webpack_public_path__ + "img/9917.aea6937f.jpg";